<!-- コード入力コンポーネント -->
<template>
  <div class="passcode__wrapper">
    <!-- クーポンコードを入力してください -->
    <p class="passcode__wrapper--title">クーポンコードを入力してください</p>
    <p class="passcode__wrapper--warning">
      ※クーポンコードには半角英数字のみ使用できます
    </p>

    <div class="passcode__form">
      <!-- 文字数制限はスペース4つ含めて19文字 -->
      <input
        v-model="inputtedCouponCode"
        type="text"
        class="coupon-input"
        maxlength="19"
      />

      <!-- スペース1つ含めて9桁未満ならdisable -->
      <ItemButton
        label="OK"
        action-type="btn-primary"
        style="margin-bottom: 50px"
        :disabled="inputtedCouponCode.length < 9"
        @clicked="clickedOk()"
      />

      <ItemButton
        label="トップへ"
        action-type="btn-primary"
        @clicked="returnNativeTopMenu()"
      />
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useVModel } from "vue-composable";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheCCInputForm",
  props: {
    propCode: {
      type: String,
    },
    onChanged: {
      type: Function,
      required: true,
    },
    clickedOk: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const inputtedCouponCode = useVModel(props, "propCode");

    const returnNativeTopMenu = () => {
      nativeHandlerService.returnNativeTopMenu();
    };

    watch(
      () => inputtedCouponCode.value,
      (code) => props.onChanged(code)
    );

    return {
      inputtedCouponCode,
      returnNativeTopMenu,
    };
  },
};
</script>

<style lang="scss" scoped>
.passcode__wrapper {
  width: 300px;
  margin: auto;
  color: black;
  top: var(--navigation-height);
  position: relative;

  .passcode__wrapper--title {
    text-align: center;
    padding: 0;
    margin-bottom: 30px;
    font-size: 14px;
  }

  .passcode__wrapper--warning {
    text-align: left;
    padding: 0;
    margin: 0 0 30px;
    font-size: 12px;
    color: black;
  }

  .passcode__form {
    position: relative;
    width: 100%;
  }

  .coupon-input {
    background: white;
    width: 100%;
    height: 50px;
    font-size: 23px;
    color: black;
    padding: 0;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 50px;
    border: 1px solid;
    border-radius: 5px;
  }
}
</style>
